import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=5cb9c2e0&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=5cb9c2e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9c2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb9c2e0')) {
      api.createRecord('5cb9c2e0', component.options)
    } else {
      api.reload('5cb9c2e0', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=5cb9c2e0&scoped=true", function () {
      api.rerender('5cb9c2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/UserInfo/Address.vue"
export default component.exports